import angular from 'angular';

angular.module('cloudX').directive('cxRelationAdministrativeCost', function() {
  return {
    restrict: 'E',
    replace: true,
    bindToController: {
      onbeforesave: '&',
      onaftersave: '&',
    },
    template: `<div>
                  <div class="margin5B">
                    <cx-enum-select data="ctrl.value.administrativeCostMethod"
                    type="administrativeCostMethod"
                    save="ctrl.submit(newValue, 'administrativeCostMethod')"
                    placeholder="'Use company setting'|translate"
                    show-placeholder-if-null="true"></cx-enum-select>
                  </div>
                  <div ng-show="!!ctrl.value.administrativeCostMethod && ctrl.value.administrativeCostMethod!==1 && ctrl.value.administrativeCostMethod === 2" class="margin5B">

                  <a editable-number="ctrl.value.administrativeCostAmount"
                  onbeforesave="ctrl.submit($data, 'administrativeCostAmount')"
                  e-step="any"
                  e-class="form-control input-xx text-right"
                  blur="submit"
                  e-cx-percentage
                  e-limit-digits="5"
                  e-max="100"
                  e-min="-100"
                  e-select-on-focus
                  e-inputgroupright="'%'"
                  ng-bind="ctrl.value.administrativeCostAmount | percentage">
                 </a>
              </div>
              <div ng-show="!!ctrl.value.administrativeCostMethod && ctrl.value.administrativeCostMethod!==1 && ctrl.value.administrativeCostMethod === 3">
                 <a editable-number="ctrl.value.administrativeCostAmount"
                 onbeforesave="ctrl.submit($data, 'administrativeCostAmount')"
                 e-step="any"
                 e-class="form-control input-xx text-right"
                 blur="submit"
                 e-select-on-focus
                 e-limit-digits="5"
                 e-min="0"
                 ng-bind="ctrl.value.administrativeCostAmount | dynCurrency:2:5">
              </a>
                </div>
              </div>`,
    require: ['ngModel', 'cxRelationAdministrativeCost'],
    link: function(scope, el, attrs, ctrl) {
      if (!ctrl || ctrl.length !== 2) return;
      var ngModel = ctrl[0];
      var controller = ctrl[1];

      controller.view2model = function(value) {
        ngModel.$setViewValue(value);
      };

      // when angular detects a change to the model,
      // we update our inner value
      ngModel.$render = function() {
        controller.setValue(ngModel.$viewValue);
      };
    },
    controllerAs: 'ctrl',
    controller: [
      '$q',
      function($q) {
        const ctrl = this;

        ctrl.setValue = function(value) {
          ctrl.value = angular.extend(
            {
              administrativeCostMethod: null,
              administrativeCostAmount: null,
            },
            ctrl.value,
            value,
          );
        };
        ctrl.setValue(null);
        ctrl.submit = function($data, field) {
          if (ctrl.value && ctrl.value[field] === $data) return false;

          let value = angular.copy(ctrl.value);
          value[field] = $data;

          return $q
            .when(
              ctrl.onbeforesave({
                $data: value,
              }),
            )
            .then(function(result) {
              // set amount to 0 if method changed
              if (field === 'administrativeCostMethod') {
                value = {
                  administrativeCostAmount: 0,
                  administrativeCostMethod: $data,
                };
              }
              if (typeof result === 'string') return result;
              if (result !== false) {
                //Update model
                if (ctrl.view2model) {
                  ctrl.view2model(value);
                }
              }
              ctrl.onaftersave({
                $data: value,
              });
              return result;
            });
        };
      },
    ],
  };
});
